import {useEffect, useState} from "react";

const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
        <>
            {"★".repeat(fullStars)}
            {halfStar && "☆"}
            {"☆".repeat(emptyStars)}
        </>
    );
};

const RatingDisplay = ({courseId}) => {
    const [rating, setRating] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/course-feedback/show-rating?courseId=${courseId}`)
            .then(res => res.json())
            .then(data => setRating(data));
    }, [courseId]);

    if (!rating) return <p>Yükleniyor...</p>;

    return (
        <div align={"center"} className="course-footer">
            <div>
                <small>Ortalama Puan</small>
                <br/>
                <span className="star">{renderStars(rating.average)}</span>
                <br/>
                <span>({rating.average} / 5)</span>

            </div>
            <div>
                <span>{rating.count} </span>
                <br/>
                <small>Kullanıcı Yorumu</small>
            </div>


        </div>
    );
};

export default RatingDisplay;
